import { elements } from '#components/calendar/js/styles.js'
import * as generics from '#components/generics/js/styles.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import remove from '@mailobj-browser/front/js/tree/remove.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const { parse } = JSON

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const container = closest(`.${elements.resourcesList}`, button)
    const li = closest('li', button)

    if (li) {
      remove(li)
    }

    if (container) {
      const { dataset } = container
      const { scopeJson } = dataset
      const notice = one(`.${generics.elements.notice}`, container)
      const { length: total } = all('li', container)
      const { length: rsrcNOK } = all('li[data-rsrc-nok]', container)
      const { length: rsrcPast } = all('li[data-rsrc-past]', container)

      if (notice) {
        if (rsrcNOK === 0 && rsrcPast === 0) {
          remove(notice)
        } else {
          const textNode = one('p', notice)

          if (textNode && scopeJson) {
            const { notices } = parse(scopeJson)

            if (notices) {
              if (rsrcNOK === 1 || rsrcPast === 1) {
                if (total === 1) {
                  textNode.textContent = notices?.notice1
                } else {
                  textNode.textContent = notices?.notice1N
                }
              } else if (total === rsrcNOK || total === rsrcPast) {
                textNode.textContent = notices?.noticeAll
              } else {
                textNode.textContent = notices?.noticeSome
              }
            }
          }
        }
      }
    }

  }
})
export default button => {
  onClick.listen(button)
}
